import React, {useState, useEffect} from 'react'
import {Icon, Modal, Checkbox, Form, Button} from 'semantic-ui-react';
import * as ToplistsActions from '../../../actions/canvas/ToplistsActions';
import {useDispatch, useSelector} from 'react-redux';
import {Feedfilter} from '../../feedfilter'
import { useFirebase } from 'react-redux-firebase';

export function Edit(props) {
    let toplist = useSelector(({canvas_toplists}) => canvas_toplists.toplists[props.id]);
    let rules = useSelector(({feedfilter}) => feedfilter.rules);
    const firebase = useFirebase();

    console.log(props.id, toplist);

    const dispatch = useDispatch();
    useEffect(() => {

    }, [props.id]);

    return (
        <Modal
            open={true}
        >
            <Modal.Header>{(toplist.is_new)?'Neue Liste erstellen':'Liste bearbeiten'}</Modal.Header>
            <Modal.Content scrolling>
                <Form>
                    <Form.Field>
                        <label>Bezeichnung</label>
                        <input placeholder='Bezeichnung der Liste' value={(typeof toplist.name !== 'undefined')?toplist.name:''} onChange={(e) => dispatch(ToplistsActions.set('name', e.target.value))} />
                    </Form.Field>
                    <Form.Field>
                        <label>Alternativname (short)</label>
                        <input placeholder='Bezeichnung der Liste (short)' value={(typeof toplist.nameshort !== 'undefined')?toplist.nameshort:''} onChange={(e) => dispatch(ToplistsActions.set('nameshort', e.target.value))} />
                    </Form.Field>
                    <Form.Field>
                        <label>Alternativname (mobile)</label>
                        <input placeholder='Bezeichnung der Liste (mobile)' value={(typeof toplist.namemobile !== 'undefined')?toplist.namemobile:''} onChange={(e) => dispatch(ToplistsActions.set('namemobile', e.target.value))} />
                    </Form.Field>
                    <Form.Field>
                        <Checkbox label='Aktiv' onChange={(e, {checked}) => {
                            dispatch(ToplistsActions.set('active', checked));
                        }} checked={(typeof toplist.active !== 'undefined')?toplist.active:false} />
                    </Form.Field>
                </Form>
                <h4>Listeninhalt</h4>
                <div style={{
                    paddingBottom: '150px'
                }}>
                    <Feedfilter rules={toplist.rules} />
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color="red" labeled labelPosition="left" icon onClick={(e) => dispatch(ToplistsActions.cancel_edit())}>
                    Abbrechen <Icon name="cancel" />
                </Button>
                <Button color="green" labeled labelPosition="left" icon disabled={(typeof toplist.name === 'undefined' || toplist.name.length === 0)} onClick={(e) => {
                    let data = {
                        ...toplist,
                        rules: rules
                    };
                    if(typeof data.is_new !== 'undefined')
                        delete data.is_new;
                    if(typeof data.updating !== 'undefined')
                        delete data.updating;
                    if(typeof data.content !== 'undefined')
                        delete data.content;

                    dispatch(ToplistsActions.save(firebase, props.channel, props.id, data))}
                }>
                    Liste Speichern <Icon name='check' />
                </Button>
            </Modal.Actions>
        </Modal>
    )
}